var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer" },
    [
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-9" }, [
            _c("p", { staticClass: "title has-text-primary" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$store.state.customers.rfc) +
                  "\n        "
              )
            ]),
            _c("p", { staticClass: "title has-text-primary" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$store.state.customers.name) +
                  "\n        "
              )
            ]),
            _c("div", { staticClass: "buttons" }, [
              _c("div", { staticClass: "field is-grouped" }, [
                _c("p", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button is-primary",
                      on: {
                        click: function($event) {
                          return _vm.sendStatusAccountEmail(
                            _vm.$store.state.customers.id,
                            _vm.$store.state.customers.companyId
                          )
                        }
                      }
                    },
                    [
                      _c("BIcon", { attrs: { icon: "send" } }),
                      _c("span", [_vm._v(" Enviar estado de cuenta")])
                    ],
                    1
                  )
                ]),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button is-illuminating-emerald",
                        attrs: { to: { name: "NewInvoice" } }
                      },
                      [
                        _c("BIcon", { attrs: { icon: "bank" } }),
                        _c("span", [
                          _vm._v(
                            "\n                  Crear factura\n                "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "column level-right" }, [
            _c("div", { staticClass: "columns" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "column" },
                _vm._l(_vm.$store.state.customers.debtsCustomer, function(
                  debt
                ) {
                  return _c(
                    "p",
                    {
                      key: debt._id.customer,
                      staticClass: "is-4 title has-text-info level-left"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm._f("toCurrency")(
                              debt.totalAmount,
                              debt._id.currency
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _c("div", { staticClass: "columns" }, [
              _vm._m(1),
              _c(
                "div",
                { staticClass: "column" },
                _vm._l(_vm.$store.state.customers.debtsExpired, function(debt) {
                  return _c(
                    "p",
                    {
                      key: debt._id.customer,
                      staticClass: "title is-4 has-text-danger level-left"
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm._f("toCurrency")(
                              debt.totalAmount,
                              debt._id.currency
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm.$store.state.customers.creditLimit > 0
              ? _c("div", { staticClass: "columns" }, [
                  _vm._m(2),
                  _c(
                    "div",
                    { staticClass: "column" },
                    _vm._l(_vm.$store.state.customers.debtCreditLimit, function(
                      debt
                    ) {
                      return _c(
                        "p",
                        {
                          key: debt._id.customer,
                          staticClass: "is-4 title has-text-info level-left"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("toCurrency")(
                                  _vm.$store.state.customers.creditLimit -
                                    debt.totalAmount,
                                  "MXN"
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ])
        ])
      ]),
      _c("div", { staticClass: "columns is-multiline" }, [
        _c("div", { staticClass: "column is-5" }, [
          _c("div", { staticClass: "box" }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.update($event)
                  }
                }
              },
              [
                _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [
                    _c("div", { staticClass: "columns is-multiline" }, [
                      _c(
                        "div",
                        { staticClass: "column is-12" },
                        [
                          _vm.loaded
                            ? _c("Customer", {
                                attrs: { loading: _vm.loading }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _c("BLoading", {
                      attrs: { "is-full-page": false, active: _vm.loading },
                      on: {
                        "update:active": function($event) {
                          _vm.loading = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._m(3)
              ]
            )
          ])
        ]),
        _c("div", { staticClass: "column" }, [
          _c(
            "div",
            { staticClass: "box comments-wrapper" },
            [
              _vm.loaded
                ? _c("IssoComments", {
                    staticClass: "box",
                    attrs: { loading: _vm.loading }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _c("InvoicesHistory"),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c(
            "RouterLink",
            { staticClass: "button", attrs: { to: { name: "Customers" } } },
            [_vm._v("\n      Regresar\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title is-4 has-text-primary level-left" }, [
        _vm._v("\n              Deuda total\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title is-4 has-text-primary level-left" }, [
        _vm._v("\n              Deuda vencida\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title is-4 has-text-primary level-left" }, [
        _vm._v("\n              Crédito disponible\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-flex button-container" }, [
      _c(
        "button",
        { staticClass: "button is-primary", attrs: { type: "submit" } },
        [_vm._v("\n              Guardar\n            ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }